import { useAuth0 } from "@auth0/auth0-react";
import { FC, ReactNode } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { config } from "../../../config";

export const ReCaptchaWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  return (
    <>
      {!isAuthenticated && !isLoading ? (
        <GoogleReCaptchaProvider
          reCaptchaKey={config.underdotsRecaptchaSiteKey}
        >
          {children}
        </GoogleReCaptchaProvider>
      ) : (
        <>{children}</>
      )}
    </>
  );
};
